import section1Img from '../static/img/section1.svg';
import section3Img from '../static/img/section2.svg';
import section2Img from '../static/img/section3.svg';
import section4Img from '../static/img/section4.svg';
import section5Img from '../static/img/section5.svg';
import section6Img from '../static/img/section6.svg';
import krasty1 from '../static/img/krasty-section1.svg';
import krasty2 from '../static/img/krasty-section2.svg';

const sectionData = [
  {
    id: 'section1',
    sectionType: 'MainFeatureSection',
    h: 'Na Seznam i do Emailu rychlostí blesku',
    p: 'Seznam načte rychleji než jiné prohlížeče. Stačí kdykoli kliknout na „esko“ a jste doma. Navíc vám dá vědět, když přijde nový e-mail. Kliknete na obálku a jste ve schránce.',
    contentImg: krasty1,
    image: section1Img,
    reverseContent: true,
  },
  {
    id: 'section2',
    sectionType: 'MainFeatureSection',
    h: 'Nedočtené články i oblíbené uložíte jedním kliknutím',
    p: `Utíkáte na vlak a nestíháte dočíst článek nebo dokoukat video? Uložte si ho na později kliknutím na ikonu knížky a mrkněte se v klidu po cestě.<br>
Máte stránku, na kterou se často vracíte? Kliknutím na hvězdičku si ji uložíte a už ji nebudete muset znovu hledat. Co si uložíte na počítači, máte pak  i na mobilu a naopak.`,
    image: section2Img,
    reverseContent: false,
  },
  {
    id: 'section3',
    sectionType: 'MainFeatureSection',
    h: 'Vše potřebné najdete v bočním panelu',
    p: 'Ke všemu, co jste si uložili, se dostanete jedním kliknutím na ikonku vedle obálky. V bočním panelu najdete své oblíbené, zajímavý obsah, který jste si uložili na později, nebo historii prohlížení a stahování. Jednotlivé položky navíc můžete označit a hromadně upravovat.',
    image: section3Img,
    reverseContent: true,
  },
  {
    id: 'section4',
    sectionType: 'MainFeatureSection',
    h: 'Mluví hezky česky',
    p: 'Slovníky nechte v šuplíku. Stačí kliknout na ikonu Krastyho a celá stránka se přeloží do češtiny. Jednotlivá slova nebo označené části textu přeložíte kliknutím pravým tlačítkem myši.',
    image: section4Img,
    contentImg: krasty2,
    reverseContent: false,
  },
  {
    id: 'section5',
    sectionType: 'MainFeatureSection',
    h: 'Prohlížejte internet bezpečně',
    p: 'Užívejte si internet bez starostí o své bezpečí. Spolupracujeme s ČOI a českými bankami, které nás ihned informují o podvodných stránkách. Před vstupem na takovou stránku vás prohlížeč důsledně varuje, abyste nenaletěli podvodníkům.',
    image: section5Img,
    reverseContent: true,
  },
  {
    id: 'section6',
    sectionType: 'MainFeatureSection',
    h: 'Nevíte si rady?',
    p: 'V jednoduché nápovědě najdete podrobný popis našich služeb a řešení konkrétních problémů. Pokud nebude stačit nápověda, můžete kontaktovat naši technickou podporu, která vám ráda pomůže.',
    image: section6Img,
    reverseContent: false,
    button: {
      desc: 'Jít do nápovědy',
      href: 'https://napoveda.seznam.cz/cz/seznam-prohlizec-nejcastejsi-dotazy/',
    },
  },
];

export default sectionData;
